/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, useEffect, useState } from 'react';
import './AgentActions.scss';
import { kebabMenuIcon } from '../../../images/images';
import { Modal } from '../../../UiKit';
import OnClickOutside from 'sushiweb/HOC/OnClickOutside';
import MenuItem from 'sushiweb/MenuItem';
import { getBlinkitActionsList } from './atoms/utils';
import {
  KEBAB_MENU_EVENTS,
  sendKebabMenuEvents,
} from '../../../helpers/analytics/kebabMenu.analytics';
import { agentActionsModel } from '../../../api';
import { popUpClosedEvent, popUpOpenendEvent } from '../../../analytics/events';
import {
  EventType,
  FeatureName,
  MetricsForJumboEvent,
} from '../../../analytics/constants';

export const AgentActions = ({
  orderId = null,
  orderBasicInfo = null,
  userId = null,
  isNewUser = false,
}) => {
  const [isMenuVisible, setMenuVisibility] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalVisible, setModalVisibility] = useState(false);
  const [list, setList] = useState(() =>
    getBlinkitActionsList.filter((item) => item.showAlways),
  );
  const kebabMenuEventDetails = {
    event_type: EventType.CLICK,
    feature_name: FeatureName.KEBAB_MENU,
    [MetricsForJumboEvent.order_id]: orderId,
    [MetricsForJumboEvent.customer_id]: userId,
  };

  useEffect(() => {
    if (orderId != null && orderId != undefined) {
      agentActionsModel
        .getKebabItems({
          params: { order_id: orderId || '', user_id: userId },
        })
        .then((res) => {
          if (!res || res?.isError) {
            return;
          }
          // setList(res);
          const filtered = res.filter(
            (item) => item.slug !== 'get_wallet_transactions',
          );
          setList((list) => [...list, ...filtered]);
        });
    }
  }, [orderId, userId]);

  const openActionsMenu = useCallback(() => {
    popUpOpenendEvent(kebabMenuEventDetails);
    setMenuVisibility(true);
  }, [orderId, userId]);

  const closeActionsMenu = useCallback(() => {
    popUpClosedEvent(kebabMenuEventDetails);
    setMenuVisibility(false);
  }, [orderId, userId]);

  const onSelectMenuItem = useCallback(
    (item) => {
      // Jumbo event for kebab menu item selection
      sendKebabMenuEvents(
        KEBAB_MENU_EVENTS.KEBAB_MENU_SELECTED_ITEM,
        orderId,
        userId,
        { selected_item: String(item.title) },
      );

      closeActionsMenu();

      // If the item is a link, open it in a new tab
      if (item.type === 'link' && item.url) {
        window.open(item.url, '_blank');
        return;
      }

      const blinkitItem = getBlinkitActionsList.find(
        (i) => i.slug === item.slug,
      );

      setSelectedItem(blinkitItem);

      sendKebabMenuEvents(
        KEBAB_MENU_EVENTS.KEBAB_MENU_MODAL_OPEN,
        orderId,
        userId,
        { item: String(item.title) },
      );

      setModalVisibility(true);
    },
    [orderId, userId, closeActionsMenu],
  );

  const closeModal = useCallback(() => {
    sendKebabMenuEvents(
      KEBAB_MENU_EVENTS.KEBAB_MENU_MODAL_CLOSE,
      orderId,
      userId,
      { item: String(selectedItem.title) },
    );
    setModalVisibility(false);
    setSelectedItem(null);
  }, [orderId, userId, selectedItem]);

  const renderPopup = useCallback(() => {
    if (!selectedItem) return;
    const Comp = getBlinkitActionsList.find(
      (item) => item.slug === selectedItem.slug,
    ).value;
    return (
      <Comp
        orderId={orderId}
        userId={userId}
        isNewUser={isNewUser}
        item={selectedItem}
        closePopup={closeModal}
      />
    );
  }, [orderId, userId, isNewUser, selectedItem, closeModal]);

  return (
    <div className='agentActions'>
      <div className='menuIcon' onClick={() => openActionsMenu()}>
        <img src={kebabMenuIcon} alt='' />
      </div>
      {isMenuVisible && (
        <div className='menu'>
          <OnClickOutside handleClickOutside={closeActionsMenu}>
            <div className='agentActionsList col'>
              {list?.map((item, index) => (
                <MenuItem
                  key={index}
                  value={item.title}
                  label={item.title}
                  fontSize='14px'
                  disabled={item.disabled}
                  isMultiliner={true}
                  _passClick={() => onSelectMenuItem(item)}
                />
              ))}
            </div>
          </OnClickOutside>
        </div>
      )}
      {isModalVisible && (
        <div>
          <Modal
            padding={0}
            isVisible={isModalVisible}
            title={
              selectedItem?.heading ? (
                selectedItem.titleStyle ? (
                  <div style={{ ...selectedItem.titleStyle }}>
                    {selectedItem.heading}
                  </div>
                ) : (
                  <>{selectedItem.heading}</>
                )
              ) : (
                'Agent Action'
              )
            }
            type={(selectedItem && selectedItem.modalType) || 'large'}
            handleClose={closeModal}
            component={renderPopup()}
            minHeight={(selectedItem && selectedItem.minHeight) || '300px'}
            maxHeight={(selectedItem && selectedItem.maxHeight) || '300px'}
            paddingTop={(selectedItem && selectedItem.paddingTop) || '1rem'}
            containerStyles={
              (selectedItem && selectedItem.containerStyles) || {
                margin: '16px 0 20px 0',
                padding: '0 20px',
              }
            }
            showScrollBar={selectedItem?.showScrollBar}
          />
        </div>
      )}
    </div>
  );
};
